'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TheatreRecommendation = require('./TheatreRecommendation');

var _TheatreRecommendation2 = _interopRequireDefault(_TheatreRecommendation);

var _MoreRecommendationsButton = require('./MoreRecommendationsButton');

var _MoreRecommendationsButton2 = _interopRequireDefault(_MoreRecommendationsButton);

require('./_theatre-recommendations.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TheatreRecommendations = function (_PureComponent) {
  _inherits(TheatreRecommendations, _PureComponent);

  function TheatreRecommendations(props) {
    _classCallCheck(this, TheatreRecommendations);

    var _this = _possibleConstructorReturn(this, (TheatreRecommendations.__proto__ || Object.getPrototypeOf(TheatreRecommendations)).call(this, props));

    _this.onScrollLeft = function (e) {
      e.stopPropagation();
      var scrollDistance = _this.props.scrollDistance;

      var newPosition = Math.min(0, _this.state.scrollPosition += scrollDistance);
      _this.setState({ scrollPosition: newPosition }, _this.forceUpdate());
    };

    _this.onScrollRight = function (e) {
      e.stopPropagation();
      var scrollDistance = _this.props.scrollDistance;

      var newPosition = _this.state.scrollPosition -= scrollDistance;
      _this.setState({ scrollPosition: newPosition }, _this.forceUpdate());

      var excess = _this.recommendationsListRef.clientWidth + newPosition;
      if (excess < 1200) {
        _this.props.fetchMoreRecommendations();
      }
    };

    _this.state = {
      scrollPosition: 0
    };
    return _this;
  }

  _createClass(TheatreRecommendations, [{
    key: 'renderRecommendations',
    value: function renderRecommendations() {
      var _props = this.props,
          onClickRecommendation = _props.onClickRecommendation,
          recommendations = _props.recommendations,
          selectedIndex = _props.selectedIndex;


      return recommendations.map(function (recommendation, index) {
        var _React$createElement;

        return _react2.default.createElement(_TheatreRecommendation2.default, (_React$createElement = {
          key: index,
          index: index,
          isSelected: index === selectedIndex
        }, _defineProperty(_React$createElement, 'key', index), _defineProperty(_React$createElement, 'onClick', onClickRecommendation), _defineProperty(_React$createElement, 'recommendation', recommendation), _React$createElement));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var scrollPosition = { left: this.state.scrollPosition };
      var showScrollLeft = this.state.scrollPosition !== 0;

      return _react2.default.createElement(
        'div',
        { className: 'theatre-recommendations-container' },
        _react2.default.createElement(
          'div',
          {
            className: 'theatre-recommendations',
            style: scrollPosition,
            ref: function ref(recommendationsList) {
              _this2.recommendationsListRef = recommendationsList;
            } },
          this.renderRecommendations()
        ),
        showScrollLeft && _react2.default.createElement(
          'div',
          { className: 'theatre-recommendations__scroll-button theatre-recommendations__scroll-button--left' },
          _react2.default.createElement(_MoreRecommendationsButton2.default, { isLeft: true, onClick: this.onScrollLeft })
        ),
        _react2.default.createElement(
          'div',
          { className: 'theatre-recommendations__scroll-button theatre-recommendations__scroll-button--right' },
          _react2.default.createElement(_MoreRecommendationsButton2.default, { onClick: this.onScrollRight })
        )
      );
    }
  }]);

  return TheatreRecommendations;
}(_react.PureComponent);

TheatreRecommendations.propTypes = {
  onClickRecommendation: _react.PropTypes.func.isRequired,
  fetchMoreRecommendations: _react.PropTypes.func.isRequired,
  recommendations: _react.PropTypes.array.isRequired,
  scrollDistance: _react.PropTypes.number,
  selectedIndex: _react.PropTypes.number
};
TheatreRecommendations.defaultProps = {
  onClickRecommendation: function onClickRecommendation() {},
  recommendations: [],
  scrollDistance: 600, // this ensures that we don't scroll past items at the minimum screen size
  selectedIndex: 0
};
exports.default = TheatreRecommendations;